import { apiFetch } from './client';

export const getEntries = (params = {}) => {
  const qs = new URLSearchParams(params).toString();
  return apiFetch(`/api/entries${qs ? '?' + qs : ''}`);
};

export const getEntry = (id) => apiFetch(`/api/entries/${id}`);
